/* Paul Bond Q4 2026 theme */
(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const R = (window.PBB && window.PBB.routes) || { cart_add: '/cart/add', cart: '/cart', cart_change: '/cart/change', root: '/' };
  const fmt = cents => '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 });
  const store = {
    get(k, d) { try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  let toastT;
  const toast = msg => { const t = $('#toast'); if (!t) return; t.textContent = msg; clearTimeout(toastT); toastT = setTimeout(() => { t.textContent = ''; }, 2600); };

  /* ---------- header ---------- */
  const hdr = $('#siteHeader');
  const setHdr = () => { if (!hdr) return; hdr.classList.toggle('scrolled', scrollY > 30); document.documentElement.style.setProperty('--hdr', hdr.offsetHeight + 'px'); };
  addEventListener('scroll', setHdr, { passive: true }); addEventListener('resize', setHdr); setHdr();

  const openLayer = el => { if (!el) return; el.hidden = false; document.body.style.overflow = 'hidden'; const f = el.querySelector('[data-close]'); f && f.focus(); };
  const closeLayers = () => { $$('#drawerNav, #cartDrawer, #favDrawer').forEach(el => el.hidden = true); document.body.style.overflow = ''; };
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeLayers(); });

  /* ---------- hero slideshow ---------- */
  $$('[data-slideshow]').forEach(root => {
    const slides = $$('.slide', root); if (slides.length < 2) return;
    let i = 0, timer = null; const num = $('[data-slide-num]', root);
    const pad = n => (n < 10 ? '0' : '') + n;
    const go = d => { i = (i + d + slides.length) % slides.length; slides.forEach((s, k) => { s.classList.toggle('on', k === i); s.setAttribute('aria-hidden', k !== i); }); if (num) num.textContent = pad(i + 1) + ' / ' + pad(slides.length); };
    const ms = +root.dataset.interval || 7000;
    const start = () => { if (matchMedia('(prefers-reduced-motion: reduce)').matches) return; clearInterval(timer); timer = setInterval(() => go(1), ms); };
    root.addEventListener('click', e => {
      const b = e.target.closest('[data-slide]'); if (b) { go(+b.dataset.slide); clearInterval(timer); return; }
      const p = e.target.closest('[data-slide-pause]'); if (p) { if (timer) { clearInterval(timer); timer = null; p.setAttribute('aria-label', 'Play slideshow'); } else { start(); p.setAttribute('aria-label', 'Pause slideshow'); } }
    });
    start();
  });

  /* ---------- collection chips ---------- */
  $$('[data-chips]').forEach(box => {
    const grid = $('#grid'); if (!grid) return;
    const cards = $$('.pcw', grid);
    const mode = box.dataset.mode;
    let groups = [];
    if (mode === 'boots') {
      const styles = [...new Set(cards.map(c => c.dataset.style).filter(Boolean))];
      groups = [
        ['g', [['all', 'All'], ["Men's", "Men's"], ["Women's", "Women's"]]],
        ['style', styles.map(s => [s, s])],
        ['mat', [['calfskin', 'Calfskin'], ['suede', 'Suede']]]
      ];
    } else if (mode === 'keywords' && box.dataset.rules) {
      const rules = box.dataset.rules.split(/\n/).map(l => l.split('=')).filter(p => p.length === 2).map(([l, w]) => [w.split(',').map(x => x.trim().toLowerCase()).filter(Boolean), l.trim()]);
      const used = rules.filter(([ws]) => cards.some(c => ws.some(w => (c.dataset.title || '').includes(w))));
      groups = [['kw', [['all', 'All ' + cards.length], ...used.map(([ws, l]) => [ws.join('|'), l])]]];
    } else return;
    const state = { g: 'all', style: 'all', mat: 'all', kw: 'all' };
    const match = c => (state.g === 'all' || c.dataset.g === state.g) && (state.style === 'all' || c.dataset.style === state.style) && (state.mat === 'all' || c.dataset.mat === state.mat) && (state.kw === 'all' || state.kw.split('|').some(w => (c.dataset.title || '').includes(w)));
    const render = () => {
      let n = 0; cards.forEach(c => { const ok = match(c); c.hidden = !ok; if (ok) n++; });
      box.innerHTML = groups.map((g, gi) => (gi ? '<span class="chip-sep"></span>' : '') + g[1].map(([v, l]) => `<button type="button" class="chip ${state[g[0]] === v ? 'on' : ''}" data-k="${g[0]}" data-v="${v}" aria-pressed="${state[g[0]] === v}">${l}</button>`).join('')).join('') + `<span class="count">${n} ${mode === 'boots' ? 'styles' : 'pieces'}</span>`;
    };
    box.addEventListener('click', e => { const b = e.target.closest('.chip'); if (!b) return; const k = b.dataset.k, v = b.dataset.v; state[k] = state[k] === v && v !== 'all' ? 'all' : v; render(); });
    render();
  });

  /* ---------- product page ---------- */
  const sec = $('[data-product-section]');
  if (sec) {
    const data = JSON.parse(($('[data-product-json]') || {}).textContent || '{}');
    const form = $('[data-product-form]', sec) || $('#productForm');
    const idInput = form && $('[data-variant-id]', form);
    const optEls = $$('.opt', sec);
    const fixed = $$('input[data-opt]', sec);
    const nOpts = (data.single || []).length;
    const sel = new Array(nOpts).fill(null);
    fixed.forEach(f => { sel[+f.dataset.opt] = f.value; });
    (data.single || []).forEach((n, i) => { if (n === 1 && sel[i] == null && data.variants[0]) sel[i] = data.variants[0].options[i]; });
    const variants = data.variants || [];
    const find = s => variants.find(v => v.options.every((o, i) => s[i] == null || s[i] === o));
    const exact = () => sel.every(x => x != null) ? variants.find(v => v.options.every((o, i) => o === sel[i])) : null;

    // Gallery
    const main = $('#mainImg');
    $$('[data-media-src]', sec).forEach(b => b.addEventListener('click', () => { if (main) { main.srcset = ''; main.src = b.dataset.mediaSrc; } $$('[data-media-src]', sec).forEach(x => x.classList.toggle('on', x === b)); }));

    const refresh = () => {
      optEls.forEach(el => {
        const oi = +el.dataset.optIndex;
        $$('button[data-value]', el).forEach(b => {
          const val = b.dataset.value;
          const any = variants.filter(v => v.options[oi] === val && v.options.every((o, i) => i >= oi || sel[i] == null || sel[i] === o));
          const exists = any.length > 0;
          const avail = variants.some(v => v.options[oi] === val && v.available && v.options.every((o, i) => i === oi || sel[i] == null || sel[i] === o));
          b.toggleAttribute('data-missing', !exists);
          b.toggleAttribute('data-unavailable', exists && !avail);
          const on = sel[oi] === b.dataset.value; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on);
          const small = b.querySelector('small'); if (small) small.remove();
          const v = exists && sel.every((x, i) => i === oi || x != null) ? variants.find(vv => vv.options.every((o, i) => i === oi ? o === val : o === sel[i])) : null;
          if (v && v.available && v.qty != null && v.qty > 0 && v.qty <= 2) { const s = document.createElement('small'); s.textContent = v.qty + ' left'; b.appendChild(s); }
        });
      });
      const v = exact();
      const atc = $('#atc', sec);
      if (v) {
        idInput && (idInput.value = v.id);
        $$('[data-price]', sec).forEach(e => e.textContent = fmt(v.price).replace('.00', ''));
        $$('[data-atc-price]', sec).forEach(e => e.textContent = fmt(v.price).replace('.00', ''));
        $$('[data-inst]', sec).forEach(e => e.textContent = fmt(Math.round(v.price / 4)));
        if (atc) { atc.disabled = !v.available; if (!v.available) atc.textContent = 'Sold out'; else if (!$('[data-atc-price]', atc)) atc.innerHTML = 'Add to bag · <span data-atc-price>' + fmt(v.price).replace('.00', '') + '</span>'; }
        const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
      }
      const sa = $('#saName'), sm = $('#saMeta');
      if (sa) sa.textContent = data.title || '';
      if (sm) sm.textContent = v ? v.options.filter((o, i) => (data.single || [])[i] > 1).join(' · ') + ' · ' + fmt(v.price).replace('.00', '') : 'Choose your options';
    };
    optEls.forEach(el => el.addEventListener('click', e => {
      const b = e.target.closest('button[data-value]'); if (!b || b.hasAttribute('data-missing')) return;
      const oi = +el.dataset.optIndex; sel[oi] = b.dataset.value;
      // clear later selections that no longer exist
      for (let j = oi + 1; j < nOpts; j++) if (sel[j] != null && !find(sel)) { if (!fixed.some(f => +f.dataset.opt === j)) sel[j] = null; }
      const er = $('#sizeErr', sec); if (er) er.hidden = true;
      refresh();
    }));
    // preselect from URL variant or auto-select single-choice options (not sizes)
    const urlV = new URLSearchParams(location.search).get('variant');
    const pre = urlV && variants.find(v => String(v.id) === urlV);
    if (pre) pre.options.forEach((o, i) => sel[i] = o);
    else optEls.forEach(el => { const oi = +el.dataset.optIndex; const isSize = !!el.querySelector('.sizes'); const btns = $$('button[data-value]', el); if (!isSize && btns.length) sel[oi] = sel[oi] || btns[0].dataset.value; });
    refresh();

    // ETA
    $$('[data-eta-weeks]', sec).forEach(e => { const d = new Date(); d.setDate(d.getDate() + 7 * +e.dataset.etaWeeks); e.textContent = d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }); });
    $$('[data-eta-days]', sec).forEach(e => { const [a, b] = e.dataset.etaDays.split(',').map(Number); const add = n => { const d = new Date(); let k = 0; while (k < n) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) k++; } return d; }; const f = d => d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); e.textContent = f(add(a)) + ' – ' + f(add(b)); });

    // Add to bag
    form && form.addEventListener('submit', async e => {
      e.preventDefault();
      if (!exact()) { const er = $('#sizeErr', sec); if (er) { er.hidden = false; er.scrollIntoView({ block: 'center', behavior: 'smooth' }); } toast('Choose a size first'); return; }
      const btn = $('#atc', sec); btn && (btn.disabled = true);
      try {
        const r = await fetch(R.cart_add + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +idInput.value, quantity: 1 }] }) });
        if (!r.ok) { const j = await r.json().catch(() => ({})); toast(j.description || 'Could not add to bag'); }
        else { await openCart(); }
      } finally { btn && (btn.disabled = false); refresh(); }
    });
    // Sticky add to bag (mobile)
    const sa = $('#stickyAtc'), atc = $('#atc', sec);
    if (sa && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => sa.classList.toggle('show', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(atc);
      $('#saBtn').addEventListener('click', () => { if (exact()) form.requestSubmit(); else { atc.scrollIntoView({ block: 'center', behavior: 'smooth' }); const er = $('#sizeErr', sec); if (er) er.hidden = false; } });
    }
  }

  /* ---------- cart drawer ---------- */
  const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  async function renderCart() {
    const c = await fetch(R.cart + '.js', { headers: { Accept: 'application/json' } }).then(r => r.json());
    const cnt = $('#cartCount'); if (cnt) { cnt.textContent = c.item_count; cnt.dataset.n = c.item_count; }
    const body = $('#cartBody'), foot = $('#cartFoot'); if (!body) return c;
    if (!c.item_count) { body.innerHTML = `<p>Your bag is empty.</p><a class="btn" href="/collections/bond-boots">Shop Bond Boots</a>`; foot.hidden = true; return c; }
    const th = (window.PBB && window.PBB.freeShip) || 15000;
    body.innerHTML = `<div><p style="font-size:.88rem;margin-bottom:6px">${c.total_price >= th ? '<b>Your order ships free and insured.</b>' : 'Add ' + fmt(th - c.total_price) + ' for free insured shipping'}</p><div class="progress"><i style="width:${Math.min(100, c.total_price / th * 100)}%"></i></div></div>` +
      c.items.map((it, i) => `<div class="line-item"><img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : ''}" alt=""><div><b>${esc(it.product_title)}</b>${it.variant_title ? `<div class="fine">${esc(it.variant_title)}</div>` : ''}<div class="qty" role="group" aria-label="Quantity"><button type="button" data-line="${i + 1}" data-q="${it.quantity - 1}" aria-label="Decrease">−</button><span>${it.quantity}</span><button type="button" data-line="${i + 1}" data-q="${it.quantity + 1}" aria-label="Increase">+</button></div><div><button class="x" type="button" data-line="${i + 1}" data-q="0">Remove</button></div></div><b class="tnum">${fmt(it.final_line_price)}</b></div>`).join('');
    $('#cartSub').textContent = fmt(c.total_price);
    $('#cartShip').textContent = c.total_price >= th ? 'Free, insured' : 'Calculated at checkout';
    $('#cartInst').textContent = c.total_price <= 100000 ? '4 × ' + fmt(Math.round(c.total_price / 4)) : 'monthly';
    foot.hidden = false; return c;
  }
  async function openCart() { await renderCart(); openLayer($('#cartDrawer')); }
  document.addEventListener('click', async e => {
    const t = e.target;
    if (t.closest('#cartBtn')) { e.preventDefault(); openCart(); return; }
    if (t.closest('#menuBtn')) { openLayer($('#drawerNav')); return; }
    if (t.closest('#favBtn')) { openFavs(); return; }
    if (t.closest('[data-close]') || t.classList.contains('overlay') || t.classList.contains('scrim')) { if (t.closest('a[href]') && !t.closest('[data-close]')) return; closeLayers(); return; }
    const q = t.closest('[data-line]');
    if (q) { await fetch(R.cart_change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: +q.dataset.line, quantity: +q.dataset.q }) }); renderCart(); return; }
    const j = t.closest('[data-jump]');
    if (j) { const el = document.getElementById(j.dataset.jump); if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth' }); } return; }
    const f = t.closest('[data-fav]');
    if (f) { e.preventDefault(); toggleFav(f.dataset.fav); return; }
  });
  $$('#drawerNav a').forEach(a => a.addEventListener('click', closeLayers));

  /* ---------- favorites ---------- */
  let favs = store.get('pbb-favs', []);
  const paintFavs = () => {
    const n = $('#favCount'); if (n) { n.textContent = favs.length; n.dataset.n = favs.length; }
    $$('[data-fav]').forEach(b => { const on = favs.includes(b.dataset.fav); b.classList.toggle('on', on); b.setAttribute('aria-pressed', on); });
  };
  const toggleFav = h => { favs = favs.includes(h) ? favs.filter(x => x !== h) : [...favs, h]; store.set('pbb-favs', favs); paintFavs(); toast(favs.includes(h) ? 'Saved to favorites' : 'Removed from favorites'); };
  async function openFavs() {
    const body = $('#favBody'); if (!body) return;
    body.innerHTML = favs.length ? '<p>Loading…</p>' : `<p>Tap the star on any product to save it here.</p><a class="btn" href="/collections/bond-boots">Shop Bond Boots</a>`;
    openLayer($('#favDrawer'));
    if (!favs.length) return;
    const items = await Promise.all(favs.map(h => fetch('/products/' + h + '.js').then(r => r.ok ? r.json() : null).catch(() => null)));
    body.innerHTML = items.filter(Boolean).map(p => `<div class="line-item"><img src="${p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : ''}" alt=""><div><b>${esc(p.title)}</b><div class="fine">${fmt(p.price)}</div><div style="margin-top:6px"><a class="link" href="${p.url || '/products/' + p.handle}">View</a></div></div><button class="fav on" type="button" data-fav="${p.handle}" aria-pressed="true" aria-label="Remove from favorites"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"><path d="m12 3 2.7 5.6 6.1.8-4.5 4.3 1.1 6.1L12 16.9l-5.4 2.9 1.1-6.1-4.5-4.3 6.1-.8z"/></svg></button></div>`).join('') + '<p class="fine">Favorites are saved on this device.</p>';
  }
  paintFavs();

  /* ---------- fitting guide calculator ---------- */
  const lf = $('#lenForm');
  if (lf) {
    const MEN = ['7', '7.5', '8', '8.5', '9', '9.5', '10', '10.5', '11', '11.5', '12', '13'], WOMEN = ['5', '5.5', '6', '6.5', '7', '7.5', '8', '8.5', '9', '9.5', '10', '11'];
    lf.addEventListener('submit', e => {
      e.preventDefault();
      const g = $('#lg').value; let len = parseFloat(($('#lv').value || '').replace(',', '.'));
      const out = $('#lenOut');
      if (!len) { out.innerHTML = '<p class="err">Enter your foot length.</p>'; return; }
      if ($('#lu').value === 'cm') len = len / 2.54;
      const raw = len * 3 - (g === 'men' ? 22 : 21); const list = g === 'men' ? MEN : WOMEN;
      const pick = list.reduce((b, a) => Math.abs(parseFloat(a) - raw) < Math.abs(parseFloat(b) - raw) ? a : b);
      const off = raw < parseFloat(list[0]) - .5 || raw > parseFloat(list[list.length - 1]) + .5;
      out.innerHTML = off ? `<p style="margin-top:14px">That length is outside our standard sizes. Call or text the shop at (520) 281-0512, or ask about a custom pair.</p>` : `<p style="margin-top:14px">Start with <b>US ${g === 'men' ? "men's" : "women's"} ${pick}</b>. If regular-width shoes press on the sides of your foot, choose Wide.</p>`;
    });
  }
})();
